import generateQueryParams from '@/utils/generateQueryParams';
import axiosInstance from '@/plugins/api/axiosInstance';

export default function prepack() {
    return {
        index,
        get,
        create,
        update,
        remove,
        addImage,
        removeImage
    };

    function index(options = {}) {
        const defaultValues = {
            limit: 25,
            cursor: null,
            agency: null
        };
        const params = generateQueryParams(options, defaultValues);
        return axiosInstance.get(`prepack/search${params}`);
    }

    function get(id) {
        return axiosInstance.get(`prepack/get?id=${id}`);
    }

    function create(payload) {
        const formData = new FormData();
        formData.append('arriveDate', payload['arriveDate']);
        formData.append('agency', payload['agency']);
        formData.append('tracking', payload['tracking']);
        formData.append('aux', payload['aux']);
        formData.append('weight', payload['weight']);
        formData.append('pieces', payload['pieces']);

        if (payload['type'] != undefined) {
            formData.append('type', payload['type']);
        }

        return axiosInstance.post('prepack/create', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    }

    function update(payload) {
        const formData = new FormData();
        formData.append('id', payload['id']);
        formData.append('arriveDate', payload['arriveDate']);
        formData.append('agency', payload['agency']);
        formData.append('tracking', payload['tracking']);
        formData.append('aux', payload['aux']);
        formData.append('weight', payload['weight']);
        formData.append('pieces', payload['pieces']);

        if (payload['type'] != undefined) {
            formData.append('type', payload['type']);
        }

        return axiosInstance.post('prepack/update', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    }

    function remove(ids) {
        return axiosInstance.delete(`prepack/delete`, {
            data: {
                ids: ids
            }
        });
    }

    function addImage(image, id, comment = '') {
        const formData = new FormData();
        formData.append('file', image);
        formData.append('comment', comment);
        formData.append('id', id);

        return axiosInstance.post('prepack/add-image', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    }

    function removeImage(id) {
        return axiosInstance.delete(`prepack/delete-image`, {
            data: {
                prepackId: id
            }
        });
    }
}
